import { ApiResponse, baseApi, QueryTag } from 'shared/api';

import { ICurrentUser } from './types';

export const userApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    currentUser: builder.query<ICurrentUser, void>({
      query: () => ({
        url: '/api/v1/current_user',
        method: 'GET',
      }),
      transformResponse: (response: ApiResponse<ICurrentUser>) => response.data,
      providesTags: [QueryTag.CurrentUser],
    }),
  }),
});

export const { useCurrentUserQuery } = userApi;

// Type alias for backward compatibility
export type CurrentUser = ICurrentUser;
